/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetSessionsResponse } from '../../models/get-sessions-response';

export interface GetSessions$Params {
  agent_id: string;
}

export function getSessions(http: HttpClient, rootUrl: string, params: GetSessions$Params, context?: HttpContext): Observable<StrictHttpResponse<GetSessionsResponse>> {
  const rb = new RequestBuilder(rootUrl, getSessions.PATH, 'get');
  if (params) {
    rb.query('agent_id', params.agent_id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetSessionsResponse>;
    })
  );
}

getSessions.PATH = '/sessions';
